import { endpoints } from "config/endpoints.config"
import { GenericResource, IGenericModel, generic } from "models/generic"
import { ITransactionStatusV2 } from "./transactionsV2"

export type ITransactionStatus = "paid" | "pending_payment" | "unpaid" | "canceled" | "ended" | "trialing" | "waiting_payment"
export type PaymentMethod = "credit_card" | "boleto" | "pix" | null

export interface ITransaction extends GenericResource {
  id: string
  createdAt: string
  expiresAt: string
  amount: number
  boleto_url: string
  boleto_barcode: string
  card_brand: string
  card_holder_name: string
  card_last_digits: string
  status: ITransactionStatus | ITransactionStatusV2

  // V2
  tax_invoice: {
    externalId: string
    issue_date: string
    number: string
    pdf_url: string
    status: string
    reference_month: string
    created_at: string
    updated_at: string
  }
  subscription_version?: number | null
  paid_at?: string | null
  payment_method?: PaymentMethod
  period_start?: string | null
  period_end?: string | null
}

export const transactions: IGenericModel<ITransaction> = {
  ...generic(endpoints.PAYMENT_TRANSACTIONS),
}
